import React from 'react'

const UserDash = () => {
  return (
    <div>UserDash</div>
  )
}

export default UserDash